import dynamic from "next/dynamic";

export const CoinImage = dynamic(() => import("./CoinImage"), {
  ssr: false
});
